<template>
  <router-view/>
</template>

<script>
import store from '@/stores/game';

export default {
  name: 'App',
  store: store
};
</script>



// WEBPACK FOOTER //
// src/App.vue